import React, { useState, useEffect } from 'react';
import { ConditionalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import { Image } from 'semantic-ui-react';
import "./theme/_main.scss";
import FadeInSection from "../../customizations/components/theme/Animations/FadeInSection";

const View = ({ data, isEditMode }) => {
    const [elemWidth, setElemWidth] = useState("twelve");

    useEffect(() => {
        const length = data?.elems?.length || 0;
        if (length % 4 === 0) {
            setElemWidth("three");
        } else if (length % 3 === 0) {
            setElemWidth("four");
        } else if (length % 2 === 0) {
            setElemWidth("six");
        }
    }, [data]);

    if (!data) {
        return <div>Missing data</div>;
    }

    return (
        <section
            className="full-width icon-grid custom-block"
            role="region"
            aria-labelledby="icon-grid-heading"
        >
            <div className="q container layout">
                <h2 id="icon-grid-heading" className="visually-hidden">
                    Icon Grid Section
                </h2>
                <div className="ui twelve column grid column-grid">
                    {data.elems?.map((elem, index) => (

                        <div
                            key={index}
                            className={`${elemWidth} wide computer twelve wide mobile six wide tablet column column-blocks-wrapper`}
                        >
                            <FadeInSection>

                                <ConditionalLink to={flattenToAppURL(elem.link)} condition={!isEditMode}>
                                    <article className="tile" role="article" aria-label={elem.titel || `Item ${index + 1}`}>
                                        {elem.image && (
                                            <Image
                                                src={flattenToAppURL(elem.image['@id'] + '/@@images/image')}
                                                alt={elem.alt || ""}
                                            />
                                        )}
                                        <h3>{elem.titel}</h3>
                                        <p>{elem.text}</p>
                                    </article>
                                </ConditionalLink>
                            </FadeInSection>

                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default View;
